// extracted by mini-css-extract-plugin
module.exports = {"cls1":"PropsTable-CssProp1_table-module--cls1--sfPS0","cls2":"PropsTable-CssProp1_table-module--cls2--1LT6e PropsTable-CssProp1_table-module--cls1--sfPS0"};